import { useEffect, useState } from 'react'

export type Market = {
  sym: string
  address: string
  fee: number
  ethPerShare: number | null
  state: 'listed' | 'unpriced' | 'no pool'
}

/** Live pool prices from our API. Returns null while loading and [] if the read
 *  failed — the ticker hides itself rather than showing invented numbers. */
export function useMarkets(): Market[] | null {
  const [markets, setMarkets] = useState<Market[] | null>(null)

  useEffect(() => {
    let alive = true
    const load = () =>
      fetch('/api/markets')
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
        .then((d) => alive && setMarkets(d.markets))
        .catch(() => alive && setMarkets([]))

    load()
    const id = setInterval(load, 60_000)
    return () => {
      alive = false
      clearInterval(id)
    }
  }, [])

  return markets
}
